import { createContext, ReactNode } from "react";
import { LibraryConfigurationProvider } from "./LibraryConfigurationContext";
import { MessagesProvider } from "./MessagesContext";
import { ThemeProvider } from "./ThemeContext";

export const ApplicationContext = createContext({});

interface ApplicationContextProviderProps {
    children: ReactNode;
}

export const ApplicationContextProvider = ({ children }: ApplicationContextProviderProps): JSX.Element => (
    <ApplicationContext.Provider value={{}}>
        <LibraryConfigurationProvider>
            <MessagesProvider>
                <ThemeProvider>
                    {children}
                </ThemeProvider>
            </MessagesProvider>
        </LibraryConfigurationProvider>
    </ApplicationContext.Provider>
);